import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import nlFlagIcon from "assets/images/flags/nl.svg";
import enFlagIcon from "assets/images/flags/en.svg";
import deFlagIcon from "assets/images/flags/de.svg";
import EN from "./locales/en/translations.json";
import NL from "./locales/nl/translations.json";
import DE from "./locales/de/translations.json";

const DETECTION_OPTIONS = {
  // localStorage first (a returning user's explicit choice), then the browser
  // language for first-time visitors, before the nl fallback.
  order: ["localStorage", "navigator"],
  caches: ["localStorage"],
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: DETECTION_OPTIONS,
    fallbackLng: "nl",
    // Only these three are supported; treat "en-US" etc. as their base language
    // so navigator detection resolves cleanly.
    supportedLngs: ["nl", "en", "de"],
    load: "languageOnly",
    resources: {
      nl: {
        translation: NL,
      },
      en: {
        translation: EN,
      },
      de: {
        translation: DE,
      },
    },
  });

i18n.languages = ["nl", "en", "de"];

export const flagIcons = { nl: nlFlagIcon, en: enFlagIcon, de: deFlagIcon };

export default i18n;
